<template>
  <div>
    <!-- Table area -->
    <div class="table-area" style="margin-top: 0px;">
      <visit-base v-model="data" :status="status" :readonly="readonly" @input="$forceUpdate()"/>
    </div>
    <!-- //Table area -->

    <!-- Grid area -->
    <visit-detail v-model="data" :status="status" @input="$forceUpdate()"/>
    <!-- //Grid area -->
  </div>
</template>

<script>
  import _ from 'lodash'

  /**
   * Query options
   */
  import VisitBase from '@/components/visit/VisitBase.vue'
  import VisitDetail from '@/components/visit/VisitDetail.vue'

  export default {
    /**
     * Properties include
     */
    props: {
      value: {
        type: Object,
        required: false
      },
      visitNo: {
        type: String,
        required: false
      },
      status: {
        type: Object,
        required: false,
        default () {
          return {
            new: false,
            loaded: false,
            readonly: false,
            change: false,
            memento: []
          }
        }
      },
      readonly: {
        type: Boolean,
        required: false,
        default: false
      },
      showEvidAtchPop: {
        type: Boolean,
        required: false,
        default: true
      },
      showWingsAtchPop: {
        type: Boolean,
        required: false,
        default: true
      },
    },
    components: {
      VisitBase,
      VisitDetail
    },
    data() {
      return {
        data: {},
      }
    },
    computed: {
      isNew() {
        return this.getId === undefined && this.data.visitNo === undefined
      },
      isLoaded() {
        return this.status.loaded
      },
      getId() {
        return this.visitNo || this.id
      },
    },
    methods: {
      getVisit() {
          return new Promise((resolve, reject) => {

            if (this.getId === undefined) {
              this.status.loaded = true
              this.status.readonly = true
              return resolve({})
            }

            this.status.loaded = false
            this.$store.commit('loading')

            this.$http.get(`/api/visit/${this.getId}`)
                    .then(response => {
                      let data = response.data.visitHeader

                      if(data.content != undefined && data.content != '')
                          data.content = data.content.replace(/(?:\r\n|\r|\n)/g, '<br />')

                      data.visitDetails = response.data.visitDetails

                      //핸드폰 번호 유형으로 변환
                      let regExp =/(01[016789])([0-9]{1}[0-9]{2,3})([0-9]{4})$/
                      let myArray
                      for(let i=0; i<data.visitDetails.length; i++){
                        myArray = regExp.exec(data.visitDetails[i].visitorMobile)
                        data.visitDetails[i].visitorMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]
                      }
                      myArray = regExp.exec(data.visitorFirstMobile)
                      data.visitorFirstMobile = myArray[1] + '-' + myArray[2] + '-' + myArray[3]

                      //this.status.readonly = data.elecApprId === null ? false:true;
                      // data.visitStatCd !== '10' && data.visitStatCd !== '15'
                      this.status.readonly = data.visitStatCd === '15' ? false:true

                      this.data = data
                      this.$emit('input', this.data)

                      this.loaded = true
                      return resolve(response)
                    })
                    .catch(response => {
                      this.$swal({
                        type: 'error',
                        text: '잘못된 접근이거나 권한이 없습니다.'
                      }).then(()=> {
                        this.$router.push({path: `/backOffice`});
                      })
                      return reject(response)
                    })
                    .finally(() => {
                      this.$store.commit('finish')
                    })
          })
      },
    },
    created() {
      // Get login info
      let l = {}
      try {
        l = this.$store.state.loginInfo
      } catch (e) {
        l = {}
      }

      // Check is new
      if (this.getId || this.data.visitNo !== undefined) {
        this.status.new = false
      } else {
        this.status.new = true
      }

      //if(this.data.elecApprId === undefined)
        this.getVisit()
    },
    watch: {
      'value': {
        immediate: true,
        deep: true,
        handler(value) {
          this.data = value || {}
          this.loaded = true
        }
      },
      'data': {
        deep: true,
        handler(value) {
          if (this.status.memento.length === 0) {
            this.status.memento.unshift(_.clone(value))
          } else {
            let c = JSON.stringify(this.status.memento[0])
            let v = JSON.stringify(v)
            if (c !== v) {
              this.status.memento.unshift(_.clone(value))
            }
          }
        }
      },
      'status.readonly'() {
        //this.getVisit()
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
